import React, { useState, useEffect } from 'react';
import { FaUser, FaInfoCircle, FaSave } from 'react-icons/fa';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Spin, notification, DatePicker } from 'antd'
import dayjs from 'dayjs';
import moment from 'moment';
import VNnum2words from 'vn-num2words';


export default function FrmAddContract() {
  // Define state for all input fields
  const [name, setName] = useState('Tên');
  const [contractCode, setContractCode] = useState('0');
  const [numberCard, setNumberCard] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [totalMoney, setTotalMoney] = useState('20000000');
  const [rateType, setRateType] = useState(1);
  const [loanTime, setLoanTime] = useState(10);
  const [frequency, setFrequency] = useState(3);
  const [rate, setRate] = useState(1.0);
  const [fromDate, setFromDate] = useState('');
  const [note, setNote] = useState('đây là note');
  const [tooltip, setTooltip] = useState('');
  const [collectorName, setCollectorName] = useState('Trong Hoang (tronghoang2001)');
  const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row

  const [username, setUsername] = useState(""); // Loading state for the skeleton


  useEffect(() => {
    setUsername(localStorage.getItem('username'))
  }, [])

  useEffect(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Lấy ngày và thêm số 0 nếu cần
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Lấy tháng (0-11) và thêm số 0
    const year = today.getFullYear(); // Lấy năm

    // Định dạng ngày theo DD/MM/YYYY
    const formattedDate = `${day}/${month}/${year}`;
    //console.log("Ngay hom nay: " + formattedDate)
    setFromDate(formattedDate); // Lưu vào state
  }, []); // Chỉ chạy một lần khi component được mount

  const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;

  const showNotification = (message, type) => {
    notification[type]({
      description: message,
      placement: 'topRight', // Notification position
    });
  };

  const handleChangeLocale = (e) => {
    // Chỉ lấy giá trị số và loại bỏ dấu phẩy
    const value = e.target.value.replace(/\./g, ''); // Xóa dấu phẩy
    setTotalMoney(value);

    if (value) {
      // Cập nhật tooltip với số chuyển đổi thành chữ
      setTooltip(VNnum2words(Number(value)));
    } else {
      setTooltip(''); // Xóa tooltip nếu không có giá trị
    }

  };

  const handleMouseLeave = () => {
    setTooltip('');
  };

  const handleChangeLoanTime = (e) => {
    // Chỉ cho phép nhập số
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setLoanTime(value);
    }
  };

  const handleChangeFrequency = (e) => {
    // Chỉ cho phép nhập số
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setFrequency(value);
    }
  };
  const handleMouseLeaveTotalMoney = () => {
    setTooltip('');
  };
  const handleChangeRate = (e) => {
    const value = e.target.value;

    // Kiểm tra xem giá trị có phải là số hoặc số thập phân
    if (/^\d*\.?\d*$/.test(value) || value === '.') {
      setRate(value);
    }
  };
  // Function to handle form submission
  const handleSubmit = async () => {
    const payload = {
      name,
      numberCard,
      phone,
      address,
      totalMoney: Number(totalMoney),
      rateType,
      loanTime: Number(loanTime), // Convert to number
      frequency: Number(frequency), // Convert to number if needed
      rate: Number(rate),
      fromDate: moment(fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      note,
      collectorName,
    };

    try {
      setLoadingItem(true);
      const token = localStorage.getItem('token'); // Lấy token từ localStorage
      const response = await axios.post(
        `${process.env.REACT_APP_API_DB_URL}/create-loan-credit`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}` // Thêm token vào header
          }
        }
      );

      let message = '';
      let type = '';
      if (response.status === 200) {
        message = 'Thêm thành công, mã HĐ: ' + response.data.loan_id;
        type = 'success';
      } else {
        type = 'error';
      }

      showNotification(message, type);
      //  console.log('Response:', response.data);
    } catch (error) {
      console.error('Error saving contract:', error);
    } finally {
      setLoadingItem(false);
    }
  };

  return (
    <div className="max-h-[80vh] overflow-y-auto">
      <h2 className="text-xl font-semibold mb-4">Thêm mới Hợp đồng</h2>
      <div className="border-t border-gray-300 pt-4">
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2 flex items-center">
            <FaUser className="mr-2" />Thông tin khách hàng
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Tên Khách hàng <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập tên khách hàng"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Mã hợp đồng <span className="text-red-500"></span>
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded disabled:bg-gray-100"
                value={''}
                onChange={(e) => setContractCode(e.target.value)}
                disabled={true}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Số CMND/Hộ chiếu</label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập số CMND/Hộ chiếu"
                value={numberCard}
                onChange={(e) => setNumberCard(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Số điện thoại</label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập số điện thoại"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium mb-1">Địa chỉ</label>
              <textarea
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập địa chỉ"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2 flex items-center">
            <FaInfoCircle className="mr-2" />Thông tin khoản vay
          </h3>
          <div className="grid grid-cols-2 gap-4">
            {/* <div>
              <label className="block text-sm font-medium mb-1">Loại tài sản thế chấp</label>
              <select
                className="w-full border border-gray-300 p-2 rounded"
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
              >
                <option>-- Không có tài sản thế chấp --</option>
              </select>
            </div> */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Tổng số tiền vay <span className="text-red-500">*</span>
                {/* <span className='ml-4'>{}</span> */}
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="w-full border border-gray-300 p-2 rounded"
                  value={totalMoney ? Number(totalMoney).toLocaleString('vi-VN') : ''}
                  onChange={handleChangeLocale}
                  onMouseLeave={handleMouseLeaveTotalMoney} // Giữ lại để xóa tooltip khi rời chuột
                />
                {tooltip && (
                  <div className="absolute bg-gray-700 text-white p-2 rounded mt-1">
                    {tooltip}
                  </div>
                )}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Hình thức lãi</label>
              <select
                className="w-full border border-gray-300 p-2 rounded"
                value={rateType}
                onChange={(e) => setRateType(e.target.value)}
              >
                <option>Lãi ngày (k/triệu)</option>
              </select>
            </div>
            {/* <div className="flex items-center">
              <input
                type="checkbox"
                className="mr-2"
                checked={prepaidrate}
                onChange={(e) => setPrepaidrate(e.target.checked)}
              />
              <label className="text-sm font-medium">Thu lãi trước</label>
            </div> */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Số ngày vay <span className="text-red-500">*</span>
              </label>
              <input
                type="text" // Chọn type là text
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập Số ngày vay"
                value={loanTime}
                onChange={handleChangeLoanTime} // Gọi hàm xử lý khi có thay đổi
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Kỳ lãi <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="VD : 10 ngày đóng lãi 1 lần thì điền số 10"
                value={frequency}
                onChange={handleChangeFrequency}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Lãi k/triệu <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập Số lãi"
                value={rate}
                onChange={handleChangeRate}
              />
            </div>
            {/* <div>
              <label className="block text-sm font-medium mb-1">Ngày vay</label>
              <input
                type="date"
                className="w-full border border-gray-300 p-2 rounded"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div> */}

            <div>
              <label className="block text-sm font-medium mb-1">Ngày vay</label>
              <DatePicker
                value={fromDate ? dayjs(fromDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
                format={'DD/MM/YYYY'}
                onChange={(date, dateString) => {
                  setFromDate(dateString); // Update fromDate when a new date is picked
                }}
              />
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium mb-1">Ghi chú</label>
              <textarea
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Nhập ghi chú"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium mb-1">NV thu tiền</label>
              <input
                type="text"
                className="w-full border border-gray-300 p-2 rounded"
                value={username}
                disabled={true}
              />
            </div>
          </div>
        </div>
        {/* <div className="flex justify-center space-x-4">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded flex items-center"
            onClick={handleSubmit}
          >
            <FaSave className="mr-2" />Lưu lại
          </button>
        </div> */}

        <div className="flex flex-col items-center mt-4">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
            onClick={handleSubmit}
          >
            <FaSave className="mr-2" />
            <span>Lưu lại</span>
            {loadingItem && ( // Show Spin only when loading
              <span className="ml-3">
                <Spin indicator={whiteSpinnerIcon} />
              </span>
            )}
          </button>
        </div>

        <p className="text-sm text-red-500 mt-4">
          *Chú ý : Khách hàng phải đảm bảo lãi suất và chi phí khi cho vay (gọi chung là "chi phí vay")
          tuân thủ quy định pháp luật tại từng thời điểm.
        </p>
      </div>
    </div>
  );
}
